// NATIVE
import React from 'react';

// CUSTOM
import { SxProps, Theme } from '@mui/material';
import { AvatarTables } from './AvatarTables';

export interface AvatarUsuariosPermissionsProps {
  urlImage?: string | null;
  typeImage?: string;
  name?: string;
  tenantId?: string;
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
}

export const AvatarUsuariosPermissions = ({
  urlImage,
  typeImage = 'image-employee',
  name,
  tenantId,
  sx,
  children,
}: AvatarUsuariosPermissionsProps) => {
  const initials =
    children ||
    (name || '')
      .split(' ')
      .filter(Boolean)
      .map((n: string) => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase() ||
    'Q';

  return (
    <AvatarTables
      urlImage={urlImage}
      typeImage={typeImage}
      tenantId={tenantId}
      alt={name || 'Avatar Empleado'}
      variant="square"
      objectFit="cover"
      sx={[
        {
          width: 140,
          height: 140,
          bgcolor: '#663cc1',
          color: '#ffffff',
          fontWeight: 700,
          fontSize: '2.5rem',
          boxShadow: '0 4px 14px rgba(0, 0, 0, 0.12)',
          border: '3px solid #ffffff',
          '& img': {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {initials}
    </AvatarTables>
  );
};
